import React from 'react';
import Layout from '../components/layout';
import SEO from '../components/seo';

const AboutPage = () => {
  return (
    <Layout>
      <SEO title="About Pollinators" />
      <div>
        <h1>About the Pollinator Project</h1>
        <p>
          Hi, and welcome to the Pollinator Project - a relationship mapping tool designed to help
          you explore the relationships of Pollinators and Pollinatees.
        </p>
        <h2>Honors &amp; Attribution</h2>
        <p>
          This is a de facto collaborative project as none of it would be acheivable without the
          efforts of so many other people. From scientists, designers, photographers and software
          engineers, a diverse set of people from around the world have contributed virtually
          everything to this project.
        </p>
        <h3>Data</h3>
        <p>
          All of the data presented here is derived from the{' '}
          <a href="https://www.npwrc.usgs.gov/pollinator/Downloads">USGS Pollinator Library</a>.
        </p>

        <h3>Iconography</h3>
        <p>Bee Icon by Serhii Smirnov from the Noun Project</p>
        <p>Flower Icon by Ben Avery from the Noun Project</p>
        <p style={{ display: 'none' }}>Plant Icon by Stella Cohen from the Noun Project</p>
      </div>
    </Layout>
  );
};

export default AboutPage;
